import {
    MembersManagementLine,
    MembersManagementFull,
    ProductsManagementLine,
    ProductsManagementFull,
    DashboardLine,
    DashboardFull,
    TablesFull,
    TablesLine,
    SaisiesFull,
    TraitementLine,
    SaisiesLine,
    TraitementFull,
    ParametresLine,
    ParametresFull,
    OrdersListLine,
    OrdersListFull,
    /*CalendarFull,
    CalendarLine,*/
    ProductsCatalogLine,
    ProductsCatalogFull,
    ShopsSettingsFull,
    NewsLine,
    ShopsSettingsLine,
    NewsFull,
    Warning,
    WarningLine,
    CustomersListLine,
    CustomersListFull,
    NotificationLine,
    NotificationFull
} from '@icons';
import { useSelector } from 'react-redux';
import { getUser } from '@features/auth/auth.slice';
import { useMemo } from 'react';
import { getValidationCount } from '@features/menu/menu.slice';

export type MenuItemsChildrenType = {
    label: string;
    url: string;
    isOnlyAdmin?: boolean;
    isLocked?: boolean;
    activePath?: string[];
};

export type MenuItemsType = {
    label: string;
    iconSrc: React.ReactNode;
    activeIconSrc: React.ReactNode;
    url?: string;
    parentItem: ParentItemType;
    color: MenuItemColor;
    childrenColor?: ChildrenColor;
    children?: MenuItemsChildrenType[];
    subPath?: string[]; //deprecated
    activePath?: string[];
    isLocked?: boolean;
    isOnlyAdmin?: boolean;
    count?: number;
};

export type ParentItemType = 'member' | 'product';
export type MenuItemColor = 'blue-cosem' | 'purple-cosem';

export type ChildrenColor = 'blue-cosem' | 'purple-cosem';

export const GeneralMenuItems: MenuItemsType[] = [
    {
        label: 'Gestion adhérents',
        iconSrc: <MembersManagementLine />,
        activeIconSrc: <MembersManagementFull />,
        url: '/members-management',
        color: 'blue-cosem',
        parentItem: 'member'
    },
    {
        label: 'Gestion site',
        iconSrc: <ProductsManagementLine />,
        activeIconSrc: <ProductsManagementFull />,
        url: '/products-management',
        color: 'purple-cosem',
        parentItem: 'product'
    }
];

export const MembersMenuItems: MenuItemsType[] = [
    {
        label: 'Tableau de bord',
        iconSrc: <DashboardLine />,
        activeIconSrc: <DashboardFull />,
        url: '/members-management',
        parentItem: 'member',
        color: 'blue-cosem'
    },
    {
        label: 'Tables',
        iconSrc: <TablesLine />,
        activeIconSrc: <TablesFull />,
        parentItem: 'member',
        color: 'blue-cosem',
        childrenColor: 'blue-cosem',
        children: [
            {
                label: 'Adhérents',
                url: '/members-management/members',
                activePath: [
                    '/members-management/members/:id/details/:tab',
                    '/members-management/members/add',
                    '/members-management/members/:id/edit'
                ]
            },
            {
                label: 'Logements',
                url: '/members-management/apartments',
                activePath: [
                    '/members-management/apartments/:id/details/:tab',
                    '/members-management/apartments/:id/bookings/add',
                    '/members-management/apartments/:id/bookings/:bookingId/edit',
                    '/members-management/apartments/:id/edit',
                    '/members-management/apartments/add'
                ]
            },
            {
                label: 'Réservations',
                url: '/members-management/bookings'
            }
        ]
    },
    {
        label: 'Saisies',
        iconSrc: <SaisiesLine />,
        activeIconSrc: <SaisiesFull />,
        parentItem: 'member',
        color: 'blue-cosem',
        childrenColor: 'blue-cosem',
        children: [
            {
                label: 'Suivi billetterie',
                url: '/members-management/ticketings',
                activePath: [
                    '/members-management/ticketings/add',
                    '/members-management/ticketings/add-multi',
                    '/members-management/ticketings/:id/edit'
                ]
            },
            { label: 'Cotisations', url: '/members-management/subscriptions' }
        ]
    },
    {
        label: 'Traitement',
        iconSrc: <TraitementLine />,
        activeIconSrc: <TraitementFull />,
        parentItem: 'member',
        color: 'blue-cosem',
        childrenColor: 'blue-cosem',
        children: [
            { label: 'Édition adhérents', url: '/members-management/members/edition', isOnlyAdmin: true },
            { label: 'Planning logements', url: '/members-management/apartments/edition' },
            { label: 'Édition billetterie', url: '/members-management/ticketings/edition' },
            { label: 'Édition cotisations', url: '/members-management/contributions/edition' },
            { label: 'Édition prestations financières', url: '/members-management/financial-benefits/edition' },
            { label: 'Édition prestations sociales', url: '/members-management/social-benefits/edition' },
            { label: 'Édition étiquettes RTC', url: '/members-management/etiquettes/edition' }
        ]
    },
    // {
    //     label: 'Élections',
    //     iconSrc: <Lock />,
    //     activeIconSrc: <Lock />,
    //     url: '/app/admin/statistics',
    //     parentItem: 'member',
    //     color: 'blue-cosem',
    //     isLocked: true
    // },
    // { label: 'Élections', iconSrc: <ElectionsLine />, activeIconSrc: <ElectionsFull />, url: '/app/admin/statistics', parentItem: 'member', color: 'blue-cosem' },
    {
        label: 'Paramètres',
        iconSrc: <ParametresLine />,
        activeIconSrc: <ParametresFull />,
        url: '/members-management/settings',
        parentItem: 'member',
        color: 'blue-cosem',
        activePath: [
            '/members-management/settings/financial-benefits',
            '/members-management/settings/social-benefits',
            '/members-management/settings/state-codes',
            '/members-management/settings/organization-codes',
            '/members-management/settings/service-codes',
            '/members-management/settings/ticket-types',
            '/members-management/settings/apartment-prices',
            '/members-management/settings/users'
        ],
        isOnlyAdmin: true
    }
];

export const ProductsMenuItems: MenuItemsType[] = [
    {
        label: 'Tableau de bord',
        iconSrc: <DashboardLine />,
        activeIconSrc: <DashboardFull />,
        url: '/products-management',
        parentItem: 'product',
        color: 'purple-cosem'
    },
    {
        label: 'Liste des commandes',
        iconSrc: <OrdersListLine />,
        activeIconSrc: <OrdersListFull />,
        url: '/products-management/orders',
        parentItem: 'product',
        color: 'purple-cosem',
        activePath: ['/products-management/orders/:id/details']
    },
    /*{
        label: 'Agenda',
        iconSrc: <CalendarLine />,
        activeIconSrc: <CalendarFull />,
        url: '/products-management/agenda',
        parentItem: 'product',
        color: 'purple-cosem'
    },*/
    {
        label: 'Catalogue produits',
        iconSrc: <ProductsCatalogLine />,
        activeIconSrc: <ProductsCatalogFull />,
        url: '/products-management/products',
        parentItem: 'product',
        color: 'purple-cosem',
        activePath: ['/products-management/products/add', '/products-management/products/:id/edit']
    },
    {
        label: 'Actualités',
        iconSrc: <NewsLine />,
        activeIconSrc: <NewsFull />,
        url: '/products-management/news',
        parentItem: 'product',
        color: 'purple-cosem',
        activePath: ['/products-management/news/add', '/products-management/news/:id/edit']
    },
    {
        label: 'Info flash',
        iconSrc: <WarningLine />,
        activeIconSrc: <Warning />,
        url: '/products-management/flash-infos',
        parentItem: 'product',
        color: 'purple-cosem',
        activePath: ['/products-management/flash-infos/add', '/products-management/flash-infos/:id/edit']
    },
    {
        label: 'Validation adhérents',
        iconSrc: <CustomersListLine />,
        activeIconSrc: <CustomersListFull />,
        url: '/products-management/members-validation',
        parentItem: 'product',
        color: 'purple-cosem',
        activePath: ['/products-management/members-validation/add', '/products-management/members-validation/:id/edit']
    },
    {
        label: 'Notifications',
        iconSrc: <NotificationLine />,
        activeIconSrc: <NotificationFull />,
        url: '/products-management/notifications',
        parentItem: 'product',
        color: 'purple-cosem',
        isOnlyAdmin: true
    },
    {
        label: 'Paramètres boutique',
        iconSrc: <ShopsSettingsLine />,
        activeIconSrc: <ShopsSettingsFull />,
        url: '/products-management/settings',
        parentItem: 'product',
        color: 'purple-cosem',
        activePath: [
            '/products-management/settings/eticket-types',
            '/products-management/settings/import-etickets',
            '/products-management/settings/etickets'
        ],
        isOnlyAdmin: true
    }
];

const filterMenuItemsByRole = (items: MenuItemsType[], isAdmin: boolean): MenuItemsType[] => {
    return items.filter((item) => {
        if (item.isOnlyAdmin && !isAdmin) {
            return false;
        }
        item.children = item.children?.filter((child) => {
            if (child.isOnlyAdmin && !isAdmin) {
                return false;
            }
            return true;
        });
        return true;
    });
};

export const useFilteredMembersMenuItems = (): MenuItemsType[] => {
    const user = useSelector(getUser);

    return useMemo(() => {
        const isAdmin = user?.role === 'admin';
        return filterMenuItemsByRole(MembersMenuItems, isAdmin);
    }, [user?.role]);
};

export const useFilteredProductsMenuItems = (): MenuItemsType[] => {
    const user = useSelector(getUser);
    const validationCount = useSelector(getValidationCount);

    return useMemo(() => {
        const isAdmin = user?.role === 'admin';
        const filteredItems = filterMenuItemsByRole(ProductsMenuItems, isAdmin);
        
        // Add validation count to the "Validation adhérents" menu item
        return filteredItems.map((item) => {
            if (item.url === '/products-management/members-validation') {
                // Only add count if it's greater than 0
                if (validationCount > 0) {
                    return { ...item, count: validationCount };
                }
            }
            return item;
        });
    }, [user?.role, validationCount]);
};
